var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{staticClass:"monospace",attrs:{"label":_vm.label,"value":_vm.value,"messages":_vm.value != _vm.initial ? 'Modified' : '',"placeholder":"Not present","disabled":""}})}
var staticRenderFns = []

export { render, staticRenderFns }